<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Pallet Receipt</li>
                </ol>
                <h4 class="main-title mb-0">Pallet Receipt</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header">
                    <h6 class="card-title">Pallet Receipt</h6>
                </div>
                    <div class="card-body">
                        <div class="row g-2">
                            <div class="col-md-4">
                                <label class="form-label">From Date</label><span class="text-danger"> *</span>
                                <input type="date" class="form-control" :class="{ 'is-invalid': errors?.from_date }" :max="today" v-model="report.from_date" />
                                <span v-if="errors?.from_date"><small class="text-danger">{{ errors?.from_date[0] }}</small></span>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label">To Date</label><span class="text-danger"> *</span>
                                <input type="date" class="form-control" :class="{ 'is-invalid': errors?.to_date }" :max="today" v-model="report.to_date" />
                                <span v-if="errors?.to_date"><small class="text-danger">{{ errors?.to_date[0] }}</small></span>
                            </div>
                            <div class="col-md-4">
                                <div style="float:right">
                                    <button type="button" class="btn btn-primary" style="margin-top:2em;margin-right:1em" @click="getPalletReceiptReport()"><i class="ri-save-line fs-18 lh-1"></i> Get</button>
                                    <button type="button" class="btn btn-secondary" style="margin-top:2em" @click="downloadPalletReceiptReport()"><i class="ri-download-line fs-18 lh-1"></i> Download</button>
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 mt-2">
                            <div class="col-md-12">
                                <div class="table-responsive table-responsive-sm">
                                    <table class="table table-bordered table-striped table-sm">
                                        <thead>
                                            <tr style="background-color:#9b9b9b;color:white;">
                                                <th class="text-center" width="1%">#</th>
                                                <th class="text-center" width="5%">Date</th>
                                                <th class="text-center" width="8%">Truck No</th>
                                                <th class="text-center" width="10%">Invoice No</th>
                                                <th class="text-center" width="10%">Consignor</th>
                                                <th class="text-center" width="5%">Pallet</th>
                                                <th class="text-center" width="5%">No of Pallets</th>
                                                <th class="text-center" width="5%">Average weight</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="inspections.length==0">
                                            <tr>
                                                <td colspan="13" class="text-center">No records found</td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr v-for="inspection, key in inspections" :key="key">
                                                <td class="text-center">{{ key+1 }}</td>
                                                <td class="text-center">{{ convertDateFormat(inspection.receipt_date_time) }}</td>
                                                <td class="text-center">{{ inspection.wagon_no }}</td>
                                                <td class="text-center">{{ inspection.receipt_no }}</td>
                                                <td class="text-center">{{ inspection.supplier_name }}</td>
                                                <td class="text-center">{{ inspection.pallet_size_name }}</td>
                                                <td class="text-center">{{ inspection.number_of_pallet }}</td>
                                                <td class="text-center">{{ inspection.weight }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
export default {
    data(){
        return{
            report:{
                from_date:'',
                to_date:'',
                excel:false
            },
            today:'',
            errors:[],
            inspections:[]
        }
    },
    mounted(){
        this.today = moment().format('yyyy-MM-DD')
        this.report.to_date = moment().format('yyyy-MM-DD')
    },
    methods:{
        convertDateFormat(date){
            if(date){
                return moment(date).format('DD-MM-yyyy hh:mm a')
            }else{
                return null
            }
        },
        downloadPalletReceiptReport(){
            window.open(this.$store.getters.apiUrl+'downloadPalletReceiptReport?from_date='+this.report.from_date+'&to_date='+this.report.to_date)
        },
        getPalletReceiptReport(){
            let vm = this;
            vm.$store
                .dispatch("post", { uri: "getPalletReceiptReport", data: vm.report })
                .then((response) => {
                    vm.inspections = response.data
                    vm.errors = []
                })
                .catch(function (error) {
                    vm.errors = error.response.data.errors;
                    vm.inspections = []
                    vm.$store.dispatch("error", error.response.data.message);
                });
        }
    }
}
</script>